module.exports = "<div class=\"favorite-toggle-directive\">\n  <a href=\"#\" class=\"favorite pull-right\" ng-click=\"favorite(type, id)\" ng-disabled=\"loading\" ng-show=\"!isFavorited && !loading\">\n    <i class=\"fa fa-heart\"></i>\n  </a>\n  <a href=\"#\" class=\"favorite pull-right favorited\" ng-click=\"favorite(type, id)\" ng-disabled=\"loading\" ng-show=\"isFavorited && !loading\">\n    <i class=\"fa fa-heart\"></i>\n  </a>\n  <a href=\"#\" class=\"favorite pull-right\" ng-show=\"loading\">\n    <i class=\"fa fa-spin fa-circle-o-notch\"></i>\n  </a>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./src/directives/favoriteToggle/template.html
// module id = 852
// module chunks = 1